import { Vue, Component } from "vue-property-decorator";
import { cloneDeep } from "lodash";

@Component
export default class FilterableTransactionDetailMixin extends Vue {
  showFilter = false;
  loading = false;
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  filter: any = {};
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  oldFilter: any = {};
  pinFilterDrawer = false;

  mounted() {
    this.oldFilter = cloneDeep(this.filter);
  }
  created() {
    this.$on("filterable-transaction-detail-filter-apply-click", () =>
      this.filterApplied()
    );
    this.$on("filterable-transaction-detail-filter-cancel-click", () =>
      this.filterCancelled()
    );
  }

  async loadData(): Promise<void> {
    //calls the loadData function in the component using this mixin
  }

  private filterApplied(): void {
    this.oldFilter = cloneDeep(this.filter);
    this.loadData();
  }

  private filterCancelled(): void {
    this.filter = cloneDeep(this.oldFilter);
  }
}
